module.exports = __webpack_public_path__ + "img/20250704.ed474766.jpg";